module.exports = __webpack_public_path__ + "img/business14_E.25ebdd44.png";